import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ExternalLink } from 'lucide-react';
import { ProductPlaceholder } from './ProductPlaceholder';
interface SquareCardProps {
  to: string;
  title: string;
  description?: string;
  actionText?: string;
  variant: 'category' | 'sector';
  sectorName?: string;
  className?: string;
  isExternal?: boolean;
}
export function SquareCard({
  to,
  title,
  description,
  actionText = 'View',
  variant,
  sectorName,
  className = '',
  isExternal = false
}: SquareCardProps) {
  const Content = () => <>
      {/* Image Area - Top 60% */}
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-100 border-b border-steel-100" data-id="element-312">
        {variant === 'category' ? <ProductPlaceholder aspectRatio="4/3" className="w-full h-full text-steel-300" data-id="element-313" /> : <div className="w-full h-full bg-navy-900 relative flex items-center justify-center overflow-hidden" data-id="element-314">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10" data-id="element-315">
              <div className="absolute inset-0 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-316" />
            </div>

            {/* Large Background Text */}
            {sectorName && <span className="absolute inset-0 flex items-center justify-center text-6xl font-black text-white opacity-5 uppercase tracking-tighter select-none scale-150 transform -rotate-12 whitespace-nowrap" data-id="element-317">
                {sectorName}
              </span>}

            <div className="w-12 h-12 rounded-full border-2 border-white/10 flex items-center justify-center relative z-10 group-hover:border-cg-orange-600 transition-colors" data-id="element-318">
              <ArrowRight className="w-5 h-5 text-white/50 group-hover:text-cg-orange-600 transition-colors" data-id="element-319" />
            </div>
          </div>}
      </div>

      {/* Info Area - Bottom 40% */}
      <div className="p-6 flex flex-col flex-1 bg-white" data-id="element-320">
        <h3 className="text-lg font-bold text-navy-900 mb-2 group-hover:text-cg-orange-600 transition-colors line-clamp-1" data-id="element-321">
          {title}
        </h3>

        {description && <p className="text-xs text-steel-500 line-clamp-2 mb-6 leading-relaxed flex-1" data-id="element-322">
            {description}
          </p>}

        <div className="mt-auto pt-4 border-t border-steel-100 flex items-center justify-between" data-id="element-323">
          <span className="text-xs font-bold uppercase tracking-wider text-navy-900 group-hover:text-cg-orange-600 transition-colors flex items-center gap-2" data-id="element-324">
            {actionText}
            {isExternal && <ExternalLink className="w-3 h-3" data-id="element-325" />}
          </span>
          <ArrowRight className="w-3.5 h-3.5 text-cg-orange-600 transform group-hover:translate-x-1 transition-transform" data-id="element-326" />
        </div>
      </div>
    </>;
  if (isExternal) {
    return <a href={to} target="_blank" rel="noopener noreferrer" className={`group flex flex-col bg-white border border-steel-200 hover:border-cg-orange-600 rounded-sm overflow-hidden transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cg-orange-600 h-full ${className}`} data-id="element-327">
        <Content data-id="element-328" />
      </a>;
  }
  return <Link to={to} className={`group flex flex-col bg-white border border-steel-200 hover:border-cg-orange-600 rounded-sm overflow-hidden transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cg-orange-600 h-full ${className}`} data-id="element-329">
      <Content data-id="element-330" />
    </Link>;
}